module.exports = __webpack_public_path__ + "media/images/Camp fire and fir tree-4a51cad6.jpg";